import axios from 'axios'
import helper from "../services/helper";
import axiosAuthInstance from "./axiosAuthClient";

import Vue from 'vue'  //added by kailash to run on ubuntu
import VueCookie from "vue-cookie"; //added by kailash to run on ubuntu
Vue.use(VueCookie); //added by kailash to run on ubuntu

import getEnv from '../utils/env';

const baseURL = getEnv('VUE_APP_API_BASE_URL');
/***** for single axios instance ******/
const axiosInstance = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json; multipart/form-data"},
 // headers: { "Content-Type": "application/json; multipart/form-data","Authorization":"Bearer " +Vue.cookie.get('auth_token')} // added by kailash to run the code for testing on ubuntu


});




axiosInstance.interceptors.response.use(response => {
  return response
}, (error) => {
  return new Promise((resolve, reject) => {
    reject(error);
  });
});

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/repositories/axiosClient.js